// extracted by mini-css-extract-plugin
export default {"landingPageBody":"At0E7gajfmvjpPgzbLrw","dark":"ITfenVFOcyLsszDj4KtD"};